// src/services/permissionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getCompanies = async () => {
  return await axios.get(`${API_URL}/vendors/`);
};

const getCompanyById = async (id) => {
  return await axios.get(`${API_URL}/vendors/${id}`);
};

const createCompany = async (data) => {
  return await axios.post(`${API_URL}/vendors/`, data);
};

const updateCompany = async (id, data) => {
  return await axios.put(`${API_URL}/vendors/${id}`, data);
};

const deleteCompany = async (id) => {
  return await axios.delete(`${API_URL}/vendors/${id}`);
};

export default {
  getCompanies,
  getCompanyById,
  createCompany,
  updateCompany,
  deleteCompany,
};
